import React from "react";
import "./Footer.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faGraduationCap,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  return (
    <footer className="Footer container">
      <section className="grid grid-3-columns-footer">
        <div className="about-app">
          <h4>Story of the App</h4>
          <hr />
          <p>
            Design of this Weather App represents solidarity to Ukraine. You can see Ukrainian national flower, or "soniashnyk", which historically define peace and cultural heritage. My thoughts and prayers are with the people of Ukraine. Glory to Ukraine!
          </p>
        </div>
        <div className="about-me">
          <h4>About creator</h4>
          <hr />
          <p>
          Hi! I am Yuliia, Ukrainian web-developer inspired by cutting-edge technologies, pixel-perfection, attractive interfaces and intuitively implemented UX. Let's collaborate to create innovative and functional web experiences for better future!
          </p>
        </div>
        <div className="about-page">
          <h4>Education journey</h4>
          <hr />
          <p>
            This project created as a part of {" "}
            <a
              href="https://www.shecodes.io"
              title="SheCodes Website"
              target="_blank"
              rel="noreferrer"
            >
              SheCodes
            </a>{" "}
            course which not only taught me how to code, but also provided a solid foundation in project management and design principles and is {" "}
            <a
              href="https://github.com/YuliiaZaharia/my-app"
              title="My app on GitHub"
              target="_blank"
              rel="noreferrer"
            >
              open-sourced.
            </a>
             I believe, turning creative ideas into a tech products is my calling.
          </p>
        </div>
      </section>
      <div className="links">
        <hr />
        <div className="footer-links">
          <div className="row" id="contact-info">
            <class className="col-sm-3 text-center">
              <a href="mailto:yuliia.zaharia@gmail.com" title="Contact me">
                <FontAwesomeIcon icon={faEnvelope} />
                <span className="email"> yuliia.zaharia@gmail.com</span>
              </a>
            </class>
            <class className="col-sm-3 text-center">
              <span className="phone-nr">
                <FontAwesomeIcon icon={faPhone} /> +974 3345 0216
              </span>
            </class>

            <class className="col-sm-2 text-center">
              <a
                href="https://www.shecodes.io/graduates/54714-yuliia-zaharia"
                target="_blank"
                rel="noreferrer"
                title="SheCodes Profile"
              >
                <FontAwesomeIcon icon={faGraduationCap} />
              </a>
            </class>
            <class className="col-sm-2 text-center">
              <a
                href="https://www.linkedin.com/in/yuliia-zaharia/"
                target="_blank"
                rel="noreferrer"
                title="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </class>
            <class className="col-sm-2 text-center">
              <a
                href="https://github.com/YuliiaZaharia"
                target="_blank"
                rel="noreferrer"
                title="GitHub"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </class>
          </div>
        </div>
      </div>
    </footer>
  );
}